import api from "./api";

/**
 * Salon uçları (backend: /api/salons). Yanıtlar ApiResponse zarfında gelir,
 * bu yüzden çağıran taraf res.data.data okur. Liste Spring Pageable döner:
 * { content, totalElements, totalPages, number }.
 */
export const salonService = {
  list: (params = {}) => api.get("/salons", { params }),
  get: (id) => api.get(`/salons/${id}`),
  create: (payload) => api.post("/salons", payload),
  onboard: (payload) => api.post("/salons/onboard", payload),
  update: (id, payload) => api.put(`/salons/${id}`, payload),
  changeStatus: (id, status) => api.patch(`/salons/${id}/status`, { status }),
  remove: (id) => api.delete(`/salons/${id}`),
  statistics: (id) => api.get(`/salons/${id}/statistics`),
  upgrade: (id, packageId) => api.post(`/salons/${id}/upgrade`, null, { params: { packageId } }),
  renew: (id, months) => api.post(`/salons/${id}/renew`, null, { params: { months } }),
  getPackageHistory: (id) => api.get(`/salons/${id}/package-history`),
};
